<template>
    <v-row class="fill-height mobile-margin-top" no-gutters>
        <v-col cols="12" xs="11" sm="11" class="px-2">
            <v-row class="px-2">
                <v-col
                    v-if="today.length === 0 && thisWeek.length === 0 && thisMonth.length === 0 && thisYear.length === 0"
                    class="d-flex justify-center mt-4"
                >
                    <span class="text-h7 font-weight-bold secondary--text text-decoration-none">YOU HAVE NOTHING TO DO</span>
                </v-col>
                <v-col cols="12" xs="12" sm="6" md="3" v-if="today.length !== 0">
                    <span class="text-h7 font-weight-bold secondary--text text-decoration-none ml-2 mb-2">TODAY ({{ today.length }})</span>
                    <v-row>
                        <v-col cols="12" xs="12" class="" v-for="(notification, index) in paginatedToday" :key="index">
                            <v-card flat class="pa-5 white">
                                <v-overlay :absolute="true" :value="notification.read" opacity="0.6" color="white" class="overlay-align">
                                    <v-icon @click.native="deleteItem(notification)" style="cursor: pointer" color="black">icons8-multiply</v-icon>
                                </v-overlay>
                                <div class="d-flex align-start body-1 font-weight-bold text-uppercase grey--text">
                                    <span class="grey--text">{{ notification.name }}</span>
                                    <v-spacer />
                                    <div class="pt-1 caption grey--text" style="line-height: 15px !important">
                                        {{ MIX_fromNow(notification.createdDateTime, 'x', false) }}
                                    </div>
                                </div>
                                <div class="font-weight-bold text-uppercase grey--text">
                                    <div class="caption" style="line-height: 15px !important">{{ notification.category }}</div>
                                </div>
                                <div>
                                    <!-- <div v-if="notification.description" class="body-2 mt-2">{{ notification.description }}</div> -->
                                    <div
                                        v-if="notification.link !== undefined && notification.link !== '' && notification.link !== null"
                                        class="mt-0 ml-0 text-left d-flex align-center"
                                    >
                                        <div class="body-2 text-uppercase">{{ notification.linkText }}</div>
                                        <v-spacer />
                                        <appbutton
                                            sizeoverride="medium"
                                            @click.native="updateNotification(notification)"
                                            label="OPEN"
                                            :type="notification.priority"
                                            iconclass="white--text"
                                            labelclass="white--text"
                                        />
                                    </div>
                                    <div v-else class="text-left">
                                        <appbutton
                                            sizeoverride="small"
                                            style="z-index: 3000 !important"
                                            @click.native="updateNotification(notification)"
                                            label="OPEN"
                                            type="grey lighten-4"
                                            iconclass="black--text"
                                            labelclass="grey--text text--darken-1"
                                        />
                                    </div>
                                </div>
                                <!-- <div class="d-flex align-start ml-1">
                                    <div class="font-weight-bold text-uppercase grey--text">
                                        <span :class="[ notification.priority + '--text' ]">{{ notification.name }}</span>
										<div class="overline" style="line-height: 15px !important;">{{ notification.category }}</div>
                                        <div class="overline" style="line-height: 15px !important;">{{ MIX_fromNow(notification.createdDateTime, 'x') }}</div>
                                    </div>
                                    <v-spacer />
                                    <div v-if="notification.read === null">
                                        <v-icon @click.native="deleteItem(notification)" style="cursor: pointer;" color="black">icons8-multiply</v-icon>
                                    </div>
                                </div>
                                <div>
                                    <div  class="body-2 mt-2">{{ notification.description }}</div>
                                    <div v-if="notification.link !== undefined && notification.link !== '' && notification.link !== null" class="mt-2">
                                        <appbutton sizeoverride="small" style="z-index: 3000 !important" @click.native="updateNotification(notification)" :label="notification.linkText" :type="notification.priority" iconclass="white--text" labelclass="white--text" />
                                    </div>
                                    <div v-else>
                                        <appbutton sizeoverride="small" style="z-index: 3000 !important" @click.native="updateNotification(notification)" label="READ" type="grey darken-1" iconclass="white--text" labelclass="white--text" />
                                    </div>
                                </div> -->
                            </v-card>
                        </v-col>
                        <v-col cols="12" xs="12" class="text-center" v-if="todayPages > 1">
                            <v-pagination color="black" v-model="currentPageToday" :length="todayPages" />
                        </v-col>
                    </v-row>
                    <!-- <v-row v-else>
                        <v-col cols="12"  class="text-center pa-2 mt-10">
                            <div class="overline" style="line-height: 15px !important;">No new notifications today</div>
                        </v-col>
                    </v-row> -->
                </v-col>

                <v-col cols="12" xs="12" sm="6" md="3" v-if="thisWeek.length != 0">
                    <span class="text-h7 font-weight-bold secondary--text text-decoration-none ml-2 mb-2">LAST 7 DAYS ({{ thisWeek.length }})</span>
                    <v-row>
                        <v-col cols="12" xs="12" class="" v-for="(notification, index) in paginatedThisWeek" :key="index">
                            <v-card flat :class="{ notificationsBackground: notification.read }" class="pa-5 white">
                                <!--overlay shows only for read notifications with delete option -->
                                <v-overlay :absolute="true" :value="notification.read" opacity="0.6" color="white" class="overlay-align">
                                    <v-icon @click.native="deleteItem(notification)" style="cursor: pointer" color="black">icons8-multiply</v-icon>
                                </v-overlay>
                                <div class="d-flex align-start body-1 font-weight-bold text-uppercase grey--text">
                                    <span class="grey--text">{{ notification.name }}</span>
                                    <v-spacer />
                                    <div class="pt-1 caption grey--text" style="line-height: 15px !important">
                                        {{ MIX_fromNow(notification.createdDateTime, 'x', false) }}
                                    </div>
                                </div>
                                <div class="font-weight-bold text-uppercase grey--text">
                                    <div class="caption" style="line-height: 15px !important">{{ notification.category }}</div>
                                </div>
                                <div>
                                    <!-- <div v-if="notification.description" class="body-2 mt-2">{{ notification.description }}</div> -->
                                    <div
                                        v-if="notification.link !== undefined && notification.link !== '' && notification.link !== null"
                                        class="mt-0 ml-0 text-left d-flex align-center"
                                    >
                                        <div class="body-2 text-uppercase">{{ notification.linkText }}</div>
                                        <v-spacer />
                                        <appbutton
                                            sizeoverride="medium"
                                            @click.native="updateNotification(notification)"
                                            label="OPEN"
                                            :type="notification.priority"
                                            iconclass="white--text"
                                            labelclass="white--text"
                                        />
                                    </div>
                                    <div v-else class="text-left">
                                        <appbutton
                                            sizeoverride="small"
                                            style="z-index: 3000 !important"
                                            @click.native="updateNotification(notification)"
                                            label="OPEN"
                                            type="grey lighten-4"
                                            iconclass="black--text"
                                            labelclass="grey--text text--darken-1"
                                        />
                                    </div>
                                </div>
                                <!-- <div class="d-flex align-start ml-1">
                                    <div class="font-weight-bold text-uppercase grey--text">
                                        <span :class="[ notification.priority + '--text' ]">{{ notification.name }}</span>
										<div class="overline" style="line-height: 15px !important;">{{ notification.category }}</div>
                                        <div class="overline" style="line-height: 15px !important;">{{ MIX_fromNow(notification.createdDateTime, 'x') }}</div>
                                    </div>
                                    <v-spacer />
                                     <div v-if="notification.read === null">
                                        <v-icon @click.native="deleteItem(notification)" style="cursor: pointer;" color="black">icons8-multiply</v-icon>
                                    </div>
                                </div>
                                <div>
                                    <div class="body-2 mt-2">{{ notification.description }}</div>
                                    <div v-if="notification.link !== undefined && notification.link !== '' && notification.link !== null" class="mt-2">
                                        <appbutton sizeoverride="small" @click.native="updateNotification(notification)" :label="notification.linkText" :type="notification.priority" iconclass="white--text" labelclass="white--text" />
                                    </div>
                                    <div v-else>
                                        <appbutton sizeoverride="small" style="z-index: 3000 !important" @click.native="updateNotification(notification)" label="READ" type="grey darken-1" iconclass="white--text" labelclass="white--text" />
                                    </div>                                    
                                </div> -->
                            </v-card>
                        </v-col>
                        <v-col cols="12" xs="12" class="text-center" v-if="thisWeekPages > 1">
                            <v-pagination color="black" v-model="currentPageThisWeek" :length="thisWeekPages" />
                        </v-col>
                    </v-row>
                    <!-- <v-row v-else>
                        <v-col cols="12" class="text-center pa-2 mt-10">
                             <div class="overline" style="line-height: 15px !important;">No other notifications this week</div>
                        </v-col>
                    </v-row> -->
                </v-col>

                <v-col cols="12" xs="12" sm="6" md="3" v-if="thisMonth.length != 0">
                    <span class="text-h7 font-weight-bold secondary--text text-decoration-none ml-2 mb-2">LAST 30 DAYS ({{ thisMonth.length }})</span>
                    <v-row>
                        <v-col cols="12" xs="12" class="" v-for="(notification, index) in paginatedThisMonth" :key="index">
                            <v-card flat :class="{ notificationsBackground: notification.read }" class="pa-5 white">
                                <!--overlay shows only for read notifications with delete option -->
                                <v-overlay :absolute="true" :value="notification.read" opacity="0.6" color="white" class="overlay-align">
                                    <v-icon @click.native="deleteItem(notification)" style="cursor: pointer" color="black">icons8-multiply</v-icon>
                                </v-overlay>
                                <div class="d-flex align-start body-1 font-weight-bold text-uppercase grey--text">
                                    <span class="grey--text">{{ notification.name }}</span>
                                    <v-spacer />
                                    <div class="pt-1 caption grey--text" style="line-height: 15px !important">
                                        {{ MIX_fromNow(notification.createdDateTime, 'x', false) }}
                                    </div>
                                </div>
                                <div class="font-weight-bold text-uppercase grey--text">
                                    <div class="caption" style="line-height: 15px !important">{{ notification.category }}</div>
                                </div>
                                <div>
                                    <!-- <div v-if="notification.description" class="body-2 mt-2">{{ notification.description }}</div> -->
                                    <div
                                        v-if="notification.link !== undefined && notification.link !== '' && notification.link !== null"
                                        class="mt-0 ml-0 text-left d-flex align-center"
                                    >
                                        <div class="body-2 text-uppercase">{{ notification.linkText }}</div>
                                        <v-spacer />
                                        <appbutton
                                            sizeoverride="medium"
                                            @click.native="updateNotification(notification)"
                                            label="OPEN"
                                            :type="notification.priority"
                                            iconclass="white--text"
                                            labelclass="white--text"
                                        />
                                    </div>
                                    <div v-else class="text-left">
                                        <appbutton
                                            sizeoverride="small"
                                            style="z-index: 3000 !important"
                                            @click.native="updateNotification(notification)"
                                            label="OPEN"
                                            type="grey lighten-4"
                                            iconclass="black--text"
                                            labelclass="grey--text text--darken-1"
                                        />
                                    </div>
                                </div>
                                <!-- <div class="d-flex align-start ml-1">
                                    <div class="font-weight-bold text-uppercase grey--text">
                                        <span :class="[ notification.priority + '--text' ]">{{ notification.name }}</span>
										<div class="overline" style="line-height: 15px !important;">{{ notification.category }}</div>
                                        <div class="overline" style="line-height: 15px !important;">{{ MIX_fromNow(notification.createdDateTime, 'x') }}</div>
                                    </div>
                                    <v-spacer />
                                      <div v-if="notification.read === null">
                                        <v-icon @click.native="deleteItem(notification)" style="cursor: pointer;" color="black">icons8-multiply</v-icon>
                                    </div>
                                </div>
                                <div>
                                    <div class="body-2 mt-2">{{ notification.description }}</div>
                                    <div v-if="notification.link !== undefined && notification.link !== '' && notification.link !== null" class="mt-2">
                                        <appbutton sizeoverride="small" @click.native="updateNotification(notification)" :label="notification.linkText" :type="notification.priority" iconclass="white--text" labelclass="white--text" />
                                    </div>
                                    <div v-else>
                                        <appbutton sizeoverride="small" style="z-index: 3000 !important" @click.native="updateNotification(notification)" label="READ" type="grey darken-1" iconclass="white--text" labelclass="white--text" />
                                    </div>                                    
                                </div> -->
                            </v-card>
                        </v-col>
                        <v-col cols="12" xs="12" class="text-center" v-if="thisMonthPages > 1">
                            <v-pagination color="black" v-model="currentPageThisMonth" :length="thisMonthPages" />
                        </v-col>
                    </v-row>
                    <!-- <v-row v-else>
                        <v-col cols="12"  class="text-center pa-2 mt-10">
                             <div class="overline" style="line-height: 15px !important;">No other notifications this month</div>
                        </v-col>
                    </v-row> -->
                </v-col>

                <v-col cols="12" xs="12" sm="6" md="3" v-if="thisYear.length != 0">
                    <span class="text-h7 font-weight-bold secondary--text text-decoration-none ml-2 mb-2">OVER 30 DAYS ({{ thisYear.length }})</span>
                    <v-row>
                        <v-col cols="12" xs="12" class="" v-for="(notification, index) in paginatedThisYear" :key="index">
                            <v-card flat :class="{ notificationsBackground: notification.read }" class="pa-5 white">
                                <!--overlay shows only for read notifications with delete option -->
                                <v-overlay :absolute="true" :value="notification.read" opacity="0.6" color="white" class="overlay-align">
                                    <v-icon @click.native="deleteItem(notification)" style="cursor: pointer" color="black">icons8-multiply</v-icon>
                                </v-overlay>
                                <div class="d-flex align-start body-1 font-weight-bold text-uppercase grey--text">
                                    <span class="grey--text">{{ notification.name }}</span>
                                    <v-spacer />
                                    <div class="pt-1 caption grey--text" style="line-height: 15px !important">
                                        {{ MIX_fromNow(notification.createdDateTime, 'x', false) }}
                                    </div>
                                </div>
                                <div class="font-weight-bold text-uppercase grey--text">
                                    <div class="caption" style="line-height: 15px !important">{{ notification.category }}</div>
                                </div>
                                <div>
                                    <!-- <div v-if="notification.description" class="body-2 mt-2">{{ notification.description }}</div> -->
                                    <div
                                        v-if="notification.link !== undefined && notification.link !== '' && notification.link !== null"
                                        class="mt-0 ml-0 text-left d-flex align-center"
                                    >
                                        <div class="body-2 text-uppercase">{{ notification.linkText }}</div>
                                        <v-spacer />
                                        <appbutton
                                            sizeoverride="medium"
                                            @click.native="updateNotification(notification)"
                                            label="OPEN"
                                            :type="notification.priority"
                                            iconclass="white--text"
                                            labelclass="white--text"
                                        />
                                    </div>
                                    <div v-else class="text-left">
                                        <appbutton
                                            sizeoverride="small"
                                            style="z-index: 3000 !important"
                                            @click.native="updateNotification(notification)"
                                            label="OPEN"
                                            type="grey lighten-4"
                                            iconclass="black--text"
                                            labelclass="grey--text text--darken-1"
                                        />
                                    </div>
                                </div>
                                <!-- <div class="d-flex align-start ml-1">
                                    <div class="font-weight-bold text-uppercase grey--text">
                                        <span :class="[ notification.priority + '--text' ]">{{ notification.name }}</span>
										<div class="overline" style="line-height: 15px !important;">{{ notification.category }}</div>
                                        <div class="overline" style="line-height: 15px !important;">{{ MIX_fromNow(notification.createdDateTime, 'x') }}</div>
                                    </div>
                                    <v-spacer />
                                     <div v-if="notification.read === null">
                                        <v-icon @click.native="deleteItem(notification)" style="cursor: pointer;" color="black">icons8-multiply</v-icon>
                                    </div>
                                </div>
                                <div>
                                    <div class="body-2 mt-1 ml-1">{{ notification.description }}</div>
                                    <div v-if="notification.link !== undefined && notification.link !== '' && notification.link !== null" class="mt-2">
                                        <appbutton sizeoverride="small" @click.native="updateNotification(notification)" :label="notification.linkText" :type="notification.priority" iconclass="white--text" labelclass="white--text" />
                                    </div>
                                    <div v-else>
                                        <appbutton sizeoverride="small" style="z-index: 3000 !important" @click.native="updateNotification(notification)" label="READ" type="grey darken-1" iconclass="white--text" labelclass="white--text" />
                                    </div>                                    
                                </div> -->
                            </v-card>
                        </v-col>
                        <v-col cols="12" xs="12" class="text-center" v-if="thisYearPages > 1">
                            <v-pagination color="black" v-model="currentPageThisYear" :length="thisYearPages" />
                        </v-col>
                    </v-row>
                    <!-- <v-row v-else>
                        <v-col cols="12"  class="text-center pa-2 mt-10">
                             <div class="overline" style="line-height: 15px !important;">No other notifications this year</div>
                        </v-col>
                    </v-row> -->
                </v-col>
            </v-row>
        </v-col>
        <!-- App Copyright -->
        <v-col cols="12" class="pl-2 mt-5 grey--text">
            <appcopyright />
        </v-col>
    </v-row>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
    name: 'Notifications',
    data: () => ({
        collection: 'notifications', // collection name
        collectionTitle: 'To Do',
        collectionItemTitle: 'To Do',
        customWhere: [], // where object for firebase queries
        currentPageToday: 1,
        currentPageThisWeek: 1,
        currentPageThisMonth: 1,
        currentPageThisYear: 1,
        pageSize: 4, // how many notifs you want to show per column
        todayPages: 0, // to show how many pages you need for object; value is set in today computed property
        thisWeekPages: 0, // to show how many pages you need for object; value is set in this week computed property
        thisMonthPages: 0, // to show how many pages you need for object; value is set in this week computed property
        thisYearPages: 0, // to show how many pages you need for object; value is set in this week computed property
        notificationsData: [] // get notifications from DB
    }),
    computed: {
        // COMPUTED HEADERS (GENERIC)
        ...mapGetters({
            GET_currentUser: 'GET_currentUser', // GET Current User
            GET_confirmBoxResult: 'confirmBox_store/GET_confirmBoxResult' // Get Confirm Box Result
        }),
        // COMPUTED HEADERS (CUSTOM)
        today() {
            var start = this.$moment().startOf('day')
            var end = this.$moment().endOf('day')
            var t = this
            // filter by range
            var filteredNotifications = t.MIX_filterByDateRange(t.notificationsData, start, end)
            // sort by date
            var notif = t.MIX_sortByCreatedDateTime(filteredNotifications)
            // determine no of pages today
            this.todayPages = t.MIX_noOfPages(notif, t.pageSize)
            return notif
        },
        paginatedToday() {
            const pageStart = this.currentPageToday * this.pageSize - this.pageSize
            const pageEnd = pageStart + this.pageSize
            ////console.log('start: ' + pageStart + '\nend: ' + pageEnd)
            return this.today.slice(pageStart, pageEnd)
        },
        thisWeek() {
            var start = this.$moment().startOf('day').subtract(7, 'day')
            var end = this.$moment()
            var t = this
            // filter by range
            var filteredNotifications = t.MIX_filterByDateRange(t.notificationsData, start, end)
            // remove elements that are shown in the today column
            filteredNotifications = t.MIX_hidePreviousNotifications(filteredNotifications, t.today, null, null)
            // sort  by date
            var notif = t.MIX_sortByCreatedDateTime(filteredNotifications)
            // determine no of pages this week
            this.thisWeekPages = t.MIX_noOfPages(notif, t.pageSize)
            return notif
        },
        paginatedThisWeek() {
            const pageStart = this.currentPageThisWeek * this.pageSize - this.pageSize
            const pageEnd = pageStart + this.pageSize
            ////console.log('start: ' + pageStart + '\nend: ' + pageEnd)
            return this.thisWeek.slice(pageStart, pageEnd)
        },
        thisMonth() {
            var start = this.$moment().startOf('day').subtract(30, 'day')
            var end = this.$moment().startOf('day').subtract(7, 'day')
            var t = this
            // filter by range
            var filteredNotifications = t.MIX_filterByDateRange(t.notificationsData, start, end)
            // remove elements that are shown in the today and thisWeek column
            filteredNotifications = t.MIX_hidePreviousNotifications(filteredNotifications, t.today, t.thisWeek, null)
            // sort by date
            var notif = t.MIX_sortByCreatedDateTime(filteredNotifications)
            // determine no of pages this month
            this.thisMonthPages = t.MIX_noOfPages(notif, t.pageSize)
            return notif
        },
        paginatedThisMonth() {
            const pageStart = this.currentPageThisMonth * this.pageSize - this.pageSize
            const pageEnd = pageStart + this.pageSize
            ////console.log('start: ' + pageStart + '\nend: ' + pageEnd)
            return this.thisMonth.slice(pageStart, pageEnd)
        },
        thisYear() {
            var start = this.$moment().startOf('day').subtract(365, 'day')
            var end = this.$moment().endOf('day').subtract(30, 'day')
            var t = this
            // filter by range
            var filteredNotifications = t.MIX_filterByDateRange(t.notificationsData, start, end)
            // remove elements that are shown in the today, thisWeek & thisMonth column
            filteredNotifications = t.MIX_hidePreviousNotifications(filteredNotifications, t.today, t.thisWeek, t.thisMonth)
            // sort by date
            var notif = t.MIX_sortByCreatedDateTime(filteredNotifications)
            // determine no of pages today
            this.thisYearPages = t.MIX_noOfPages(notif, t.pageSize)
            return notif
        },
        paginatedThisYear() {
            const pageStart = this.currentPageThisYear * this.pageSize - this.pageSize
            const pageEnd = pageStart + this.pageSize
            ////console.log('start: ' + pageStart + '\nend: ' + pageEnd)
            return this.thisYear.slice(pageStart, pageEnd)
        }
    },
    watch: {
        // GET CONFIRMATION RESULT
        GET_confirmBoxResult: {
            handler: async function () {
                var t = this
                if (t.GET_confirmBoxResult.data.collection === t.collection) {
                    if (t.GET_confirmBoxResult.data.result === 'YES') {
                        var deleteResult = await t.MIX_deleteDocument(t.GET_confirmBoxResult.data.collection, t.GET_confirmBoxResult.data.id)
                        if (deleteResult.code === 1) {
                            t.MIX_alert(1, `${t.collectionItemTitle} Deleted`, deleteResult.data, null)
                        } else {
                            t.MIX_alert(-1, `Error Deleting ${t.collectionItemTitle}`, null, deleteResult.error)
                        }
                    }
                } else {
                    // Do nothing
                }
            },
            deep: true
        }
    },
    methods: {
        updateBreadcrumbs() {
            var t = this
            var breadcrumbs = []
            breadcrumbs.push({ name: `${t.collectionTitle}`, path: `/${t.collection}` }) // Set the Main Path
            t.MIX_breadcrumbs(breadcrumbs)
        },
        // GET NOTICES SNAPSHOT METHOD
        getNotificationsData: async function () {
            var t = this
            var collection = t.$firebase.db.collection(t.collection)
            t.customWhere.push(
                { key: 'recipient.userId', operator: '==', value: t.GET_currentUser.id },
                { key: 'type', operator: 'array-contains', value: 'App' }
            )

            if (JSON.stringify(t.customWhere) !== '[]') {
                for (var i = 0; i < t.customWhere.length; i++) {
                    var query = { field: t.customWhere[i].key, operator: t.customWhere[i].operator, value: t.customWhere[i].value }
                    collection = collection.where(query.field, query.operator, query.value)
                }
            }
            collection.onSnapshot(function (querySnapshot) {
                t.notificationsData = []
                querySnapshot.forEach(function (doc) {
                    var document = doc.data()
                    document.id = doc.id
                    if (!document.hasOwnProperty('delete')) {
                        t.notificationsData.push(document)
                    } else if (t.showDeleted) {
                        t.notificationsData.push(document)
                    } else {
                        // Do not Show Concern
                    }
                })
            })
            return
        },
        async updateNotification(notification) {
            var t = this
            ////console.log('updateResult')
            var readMoment = this.$moment().format('x')
            var updateResult = await t.MIX_updateDocumentFieldsById(t.collection, notification.id, { read: readMoment })
            ////console.log('updateResult.code = ' + updateResult.code)
            if (updateResult.code === 1) {
                t.MIX_alert(1, 'Updated Todo', updateResult.data, null)
                t.MIX_go(notification.link)
            } else {
                t.MIX_alert(-1, 'ERROR - Could not update Todo', null, updateResult.error)
            }
        },
        // DELETE ITEM METHOD
        deleteItem: function (item) {
            var t = this
            ////console.log('item: ' + JSON.stringify(item, null, 2));
            t.MIX_confirmBox({
                show: true,
                collection: t.collection,
                id: item.id,
                title: `Delete ${t.collectionItemTitle}`,
                description: `Are you sure you want to delete ${t.collectionItemTitle}: <br /><strong>${item.name}</strong>?`,
                width: '400',
                height: '200',
                trueButtonText: 'Yes',
                trueButtonValue: 'YES',
                falseButtonText: 'No',
                falseButtonValue: 'NO'
            })
        }
    },
    mounted() {
        // BREADCRUMBS
        this.updateBreadcrumbs()
        this.MIX_setPanelLayout(12, 0, false)
        this.getNotificationsData()
        ////var testDate = '01/19/2021'
        ////console.log('HERE: ' + this.$moment(testDate, 'MM/DD/YYYY').format('x'));
    }
}
</script>

<style>
.homebutton {
    width: 155px !important;
}
.overlay-align {
    align-items: flex-start !important;
    justify-content: flex-end !important;
    padding: 20px !important;
}
.v-overlay {
    z-index: 5 !important;
}

.mobile-margin-top {
    margin-top: 24px !important;
}

@media (max-width: 599px) {
    .mobile-margin-top {
        margin-top: 90px !important;
    }
}
</style>
